import { makeAutoObservable, runInAction } from 'mobx';
import { adminShiftsGetList } from '@/services/shiftsApi';
import type { ShiftDay } from '@/types/shift.types';

/**
 * Список смен выбранного интервала. Часы центра здесь не хранятся —
 * их читает экран из operatingHoursStore.
 */
class ShiftsStore {
  shifts: ShiftDay[] = [];
  isLoading = false;
  loadError: string | null = null;
  loadedFrom: string | null = null;
  loadedTo: string | null = null;

  private requestId = 0;

  constructor() {
    makeAutoObservable(this);
  }

  load = async (from: string, to: string, serviceCenterUuid: string) => {
    if (!serviceCenterUuid) return;

    const requestId = ++this.requestId;
    this.isLoading = true;
    this.loadError = null;

    try {
      const response = await adminShiftsGetList({
        service_center_uuid: serviceCenterUuid,
        from,
        to,
      });
      if (requestId !== this.requestId) return;

      runInAction(() => {
        this.shifts = response.data ?? [];
        this.loadedFrom = from;
        this.loadedTo = to;
        this.isLoading = false;
        this.loadError = null;
      });
    } catch {
      if (requestId !== this.requestId) return;

      runInAction(() => {
        this.isLoading = false;
        this.loadError = 'Не удалось загрузить смены';
      });
    }
  };

  removeShift = (uuid: string) => {
    runInAction(() => {
      this.shifts = this.shifts.filter((shift) => shift.uuid !== uuid);
    });
  };
}

export const shiftsStore = new ShiftsStore();
export type { ShiftsStore };
